import { combineReducers } from 'redux'
import waitingRoom from './reducers/collabMiniatureWaitingRoom'

const rootReducer = combineReducers({
  waitingRoom,
})

export default rootReducer
